import camelCase from "camelcase";

export type accessorMethodPrefixType = "get" | "set";

export function propertyToAccessorString(
  property: string,
  accessorMethodPrefix: accessorMethodPrefixType,
): string {
  if (!property || !accessorMethodPrefix) {
    throw new Error(
      "Not enough parameters to convert property to getter/setter method",
    );
  }

  if (!isNaN(parseInt(property[0], 10))) {
    property = `C${property}`;
  }

  return accessorMethodPrefix + camelCase(property, { pascalCase: true });
}
